<template>
  <b-container>
    <b-card>
      <b-form @submit="addContact">
        <b-row>
          <b-col sm="12" lg="7">
            <b-form-group label="Name *" label-for="name">
              <b-form-input id="name" v-model="form.NAME_CONTACT_US" required />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="5">
            <b-form-group label="NIK *" label-for="nik">
              <b-form-input id="nik" v-model="form.NIK_CONTACT_US" required />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label="Phone *" label-for="phone">
              <b-form-input
                id="phone"
                v-model="form.PHONE_CONTACT_US"
                required
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label="Email *" label-for="email">
              <b-form-input
                id="email"
                v-model="form.EMAIL_CONTACT_US"
                type="email"
                required
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label="Telegram *" label-for="telegram">
              <b-form-input
                id="telegram"
                v-model="form.telegram"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Publish" label-for="published">
              <b-form-checkbox
                id="published"
                v-model="form.STATE_PUBLISH"
                :unchecked-value="false"
                switch
              />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button @click="$router.push({name: 'admin-settings-contacts'})" type="button" class="mr-1" variant="light">
              Cancel
            </b-button>
            <b-button type="submit" :disabled="isLoading" variant="primary">
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
  },

  data() {
    return {
      isLoading: false,
      form: {
        NAME_CONTACT_US: '',
        NIK_CONTACT_US: '',
        PHONE_CONTACT_US: '',
        EMAIL_CONTACT_US: '',
        STATE_PUBLISH: false,
        telegram: '',
        login_cs:0
      },
    }
  },

  methods: {
    addContact(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http
        .post('/settings/contact', {
          ...this.form,
        })
        .then(() => {
          this.$notif(
            'Success',
            'Contact has been successfully added.',
            'success'
          )
          this.$router.push({ name: 'admin-settings-contacts' })
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
